<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify Flexalign">
      <div class="coupon_content">
        <div class="tab_list flex">
          <div v-for="(item, index) in tabList" :key="index" class="tab_one mr-20 cursor_pointer"
            :class="[selectTab == item.value ? 'tab_one_active' : '']" @click="changeTab(item)">
            {{ item.label }}
          </div>
        </div>
        <div class="menu_list">
          <div class="flex">
            <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList"
              :key="index" @click="chaneMenu(item)" :class="{ active_menu: selectMenu == item.value }">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="order_list">
            <div class="flex Flexalign order_top FlexBetween">
              <div class="order_info">商品信息</div>
              <div class="order_empty"></div>
              <div class="order_id">订单号</div>
              <div class="order_organization">机构</div>
              <div class="order_price">金额</div>
              <div class="order_status">交易状态</div>
              <div class="order_action">操作</div>
            </div>
            <div v-if="selectTab == 1">
              <div class="order_list_content" v-if="orderList.length">
                <div class="flex Flexalign order_top FlexBetween order_one" v-for="(item, index) in orderList"
                  :key="index" :class="[index % 2 == 0 ? 'active_order_one' : '']">
                  <div class="order_info order_img">
                    <el-image class="video_img" :src="imgPath(item?.details[0]?.courseInfo?.courseCoverImg)"></el-image>
                  </div>
                  <div class="order_empty order_name">
                    {{ item?.details[0]?.courseInfo?.courseName }}
                  </div>
                  <div class="order_id">{{ item.orderNo }}</div>
                  <div class="order_organization toverflows toverflow2">
                    {{ item?.details[0]?.courseInfo?.shopName }}
                  </div>
                  <div class="order_price order_price_value">
                    ￥<span class="price_num">{{ item?.details[0]?.courseAmount }}</span>
                  </div>
                  <div class="order_status status_active">
                    {{ statusLabel(item.state) }}
                  </div>
                  <div class="order_action action_btn cursor_pointer" v-if="item.state == 2" @click="action(item)">
                    去评价
                  </div>
                  <div class="order_action flex flexcolumn FlexEnd" v-if="item.state == 1">
                    <div class="action_btn pay_now cursor_pointer" @click="payNow(item)">
                      立即付款
                    </div>
                    <div class="action_btn cancel_btn mar_top_5 cursor_pointer" @click="cancelOrder(item.orderId)">
                      取消订单
                    </div>
                  </div>
                  <div class="order_action action_btn cursor_pointer" v-if="item.state == 3" @click="action(item)">
                    重新购买
                  </div>
                </div>
              </div>
              <moe-empty url="moe_empty_bg_img.png" emptyText="暂无订单" v-else></moe-empty>
            </div>
            <div v-if="selectTab == 2">
              <div class="order_list_content" v-if="orderList.length">
                <div class="flex Flexalign order_top FlexBetween order_one" v-for="(item, index) in orderList"
                  :key="index" :class="[index % 2 == 0 ? 'active_order_one' : '']">
                  <div class="order_info order_img order_info_new flex Flexalign">
                    <el-image class="video_img paper_order_confirm_icon"
                      :src="iconPath('paper_order_confirm_icon.png')"></el-image>
                  </div>
                  <div class="order_empty order_name order_name_new">
                    <div>{{ item?.paperDocumentName }}</div>
                  </div>
                  <div class="order_id">{{ item.orderNo }}</div>
                  <div class="order_organization">
                    {{ item.shopName }}
                  </div>
                  <div class="order_price order_price_value">
                    ￥<span class="price_num">{{ item.price }}</span>
                  </div>
                  <div class="order_status status_active">
                    {{ statusLabel(item.orderStatus) }}
                  </div>
                  <div class="order_action action_btn cursor_pointer" v-if="item.orderStatus == 2"
                    @click="viewExamPaper(item)">
                    查看
                  </div>
                  <div class="order_action flex flexcolumn FlexEnd" v-if="item.orderStatus == 1">
                    <div class="action_btn pay_now cursor_pointer" @click="payExamNow(item)">
                      立即付款
                    </div>
                    <!-- <div class="action_btn cancel_btn mar_top_5 cursor_pointer" @click="cancelOrder(item.orderId)">
                    取消订单
                  </div> -->
                  </div>
                  <div class="order_action action_btn cursor_pointer" v-if="item.orderStatus == 3"
                    @click="buyAgainExamPaper(item)">
                    重新购买
                  </div>
                </div>
              </div>

              <moe-empty url="moe_empty_bg_img.png" emptyText="暂无订单" v-else></moe-empty>
            </div>
          </div>
          <div class="pagination_box flex FlexjustifyEnd" v-if="listTotal > listQuery.pageSize">
            <el-pagination background layout="prev, pager, next" :total="listTotal"
              @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>
    <learningEvaluate ref="learningEvaluate" @refreshGetList="getList"></learningEvaluate>
    <payDialog ref="payDialog" @cancelOrder="timeoutCancelOrder"></payDialog>
  </moe-page>
</template>

<script>
import learningEvaluate from "@/components/popup/learningEvaluate.vue";
import payDialog from "@/components/popup/payDialog.vue";
// import * as config from "@/config/config";
export default {
  name: "GjkcH5OrderList",

  components: {
    learningEvaluate,
    payDialog,
  },
  data() {
    return {
      menuList: [
        { label: "所有订单", value: "" },
        { label: "待付款", value: 1 },
        { label: "已付款", value: 2 },
        { label: "待评价", value: 3 },
        { label: "已关闭", value: 4 },
      ],
      selectMenu: "",
      orderList: [],
      listQuery: {
        menuStatus: "",
        page: 1,
        pageSize: 10,
      },
      listQueryPaper: {
        orderStatus: "",
        page: 1,
        pageSize: 10,
      },
      listTotal: "",
      tabList: [
        { label: "课程", value: 1 },
        { label: "试卷", value: 2 },
      ],
      selectTab: 1,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    changeTab(info) {
      this.selectTab = info.value;
      this.orderList = [];
      if (info.value == 1) {
        this.getList();
      } else {
        this.getExamPaperList();
      }
    },
    getExamPaperList() {
      this.$Api.examination
        .getExamPaperList(this.listQueryPaper)
        .then((res) => {
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.orderList = res.data.data.list;
        })
        .catch(() => { });
    },
    // 超时取消订单
    timeoutCancelOrder(orderId) {
      this.cancelOrder(orderId);
    },
    chaneMenu(info) {
      this.selectMenu = info.value;
      this.orderList = [];
      if(this.selectTab == 1){
      this.listQuery.page = 1;
      this.listQuery.menuStatus = this.selectMenu;
        this.getList();
      }else{
      this.listQueryPaper.page = 1;
      this.listQueryPaper.orderStatus = this.selectMenu;
        this.getExamPaperList();
      }
    },
    statusLabel(value) {
      if (value == 1) {
        return "未付款";
      } else if (value == 2) {
        return "已完成";
      } else if (value == 3) {
        return "已取消";
      } else if (value == 4) {
        return "待售后";
      }
    },
    actionStatus(value) {
      if (value == 1) {
        return "立即付款";
      } else if (value == 2) {
        return "去评价";
      } else if (value == 3) {
        return "重新购买";
      } else if (value == 4) {
        return "";
      }
    },
    handleCurrentChange(value) {
      if(this.selectTab == 1){
      this.listQuery.page = value;
        this.getList();
      }else{
      this.listQueryPaper.page = value;
        this.getExamPaperList();
      }
    },
    // 获取列表
    getList() {
      this.$Api.course.getCourseOrderList(this.listQuery).then((res) => {
        this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        this.orderList = res.data.data.list;
        // this.orderList = [...this.orderList, ...res.data.data.list];
      });
    },
    // 下一页
    nextPage() {
      if(this.selectTab == 1){
      this.listQuery.page++;
        this.getList();
      }else{
      this.listQueryPaper.page++;
        this.getExamPaperList();
      }
    },
    // 操作
    action(info) {
      // 评价
      if (info.state == 2) {
        this.$refs.learningEvaluate.learningEvaluateShow = true;
        this.$refs.learningEvaluate.evaluateInfo.courseId = info?.details[0]?.courseId;
      } else if (info.state == 3) {
        if (this.$Tools.empty(info.details)) return;
        this.$Api.shop
          .addCar({ courseId: info.details[0]?.courseId, type: 2 })
          .then(() => {
            this.$Jump.href("/orderConfirm", { type: 2 });
          })
          .catch((err) => {
            if (err.data.code == 910101) {
              this.$Dialog.confirm({
                message: "该课程暂未付款，是否前往订单中心，解锁该课程~",
                title: "提示", // 可选，不传则使用默认值'确认'
                onConfirm: () => {
                  // this.href("/orderList");
                }, // 确认后的操作，如调用删除API等
                onCancel: () => { },
              });
            }
          });
      }
    },
    // 立即付款
    payNow(info) {
      // 此处判断下广州那边暂时还是走模拟支付(资质未下来)
      // if (config.FILE_BASE_URL == "https://api.nsjty.com") {
      //   this.tempPay(info.orderId);
      // } else {
      this.payOrder(info);
      // }
    },
    // 立即付款
    payExamNow(info) {
      console.log(info);
      // this.$Api.shop
      //   .getPayQrcode({ orderPayType: info.paymentMode, orderId: info.orderId })
      //   .then((res) => {
      //     this.$refs.payDialog.countDown =
      //       1800 - Math.floor((this.$Moment() - this.$Moment(info.createTime)) / 1000);
      //     this.$refs.payDialog.unbindShow = true;
      //     this.$refs.payDialog.qrCodeValue = res.data.data.codeUrl;
      //     this.$refs.payDialog.orinceTotalPrice = info.actualAmount;
      //     this.$refs.payDialog.payType = info.paymentMode;
      //     this.$refs.payDialog.parentId = info.orderId;
      //     this.$refs.payDialog.orderId = info.orderId;
      //     this.$refs.payDialog.orderType = "orderList";
      //     setTimeout(() => {
      //       this.$refs.payDialog.startInterval();
      //     }, 800);
      //   })
      //   .catch(() => {});
    },
    // 试卷再次购买
    buyAgainExamPaper(info) {
      this.$Jump.href("/examPaperOrderConfirm", { paperDocumentId: info.paperDocumentId });
    },
    // 模拟支付
    tempPay(orderId) {
      this.loading = this.$loading({
        lock: true,
        text: `正在模拟支付`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$Api.course
        .tempPay({ orderId: orderId })
        .then((res) => {
          console.log(res.data.data);
          setTimeout(() => {
            this.loading.close();
            this.$Dialog.toast("支付成功");
            this.orderList = [];
            this.getList();
          }, 3000);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    payOrder(info) {
      this.$Api.shop
        .getPayQrcode({ orderPayType: info.paymentMode, orderId: info.orderId })
        .then((res) => {
          this.$refs.payDialog.countDown =
            1800 - Math.floor((this.$Moment() - this.$Moment(info.createTime)) / 1000);
          this.$refs.payDialog.unbindShow = true;
          this.$refs.payDialog.qrCodeValue = res.data.data.codeUrl;
          this.$refs.payDialog.orinceTotalPrice = info.actualAmount;
          this.$refs.payDialog.payType = info.paymentMode;
          this.$refs.payDialog.parentId = info.orderId;
          this.$refs.payDialog.orderId = info.orderId;
          this.$refs.payDialog.orderType = "orderList";
          setTimeout(() => {
            this.$refs.payDialog.startInterval();
          }, 800);
        })
        .catch(() => { });
    },
    // 取消订单
    cancelOrder(orderId) {
      this.$Api.course
        .cancelCourseOrder({ orderId: orderId })
        .then(() => {
          this.orderList = [];
          this.$Dialog.toast("订单已取消");
          this.getList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 查看试卷
    viewExamPaper(info) {
      this.href("/examPaperView", { paperDocumentId: info.paperDocumentId });
    },
  },
};
</script>
<style lang="scss" scoped>
.tab_list {
  .tab_one {
    width: 80px;
    height: 40px;
    background: #f6f7f9;
    border-radius: 12px;
    font-weight: 500;
    font-size: 16px;
    color: #8a919b;
    text-align: center;
    line-height: 40px;
  }

  .tab_one_active {
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    color: #ffffff;
  }
}

.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    min-height: 966px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .menu_list {
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .menu_one {
        line-height: 50px;
        margin-right: 20px;
        // font-weight: bold;
        font-size: 18px;
        position: relative;
      }

      .active_menu {
        // font-weight: 600;
        color: #13d6aa;
      }
    }
  }

  .content {
    .order_list {
      .order_top {
        color: #333333;
        text-align: center;
        line-height: 50px;
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
        // font-weight: 600;

        .order_info {
          width: 160px;

          .video_img {
            width: 140px;
            height: 90px;
            border-radius: 5px;
          }

          .paper_order_confirm_icon {
            width: 42px;
            height: 42px;
          }
        }

        .order_info_new {
          width: 40px;
        }

        .order_img {
          height: 90px;
        }

        .order_empty {
          width: 150px;
          height: 50px;
          text-align: left;
        }

        .order_name {
          width: 250px;
        }

        .order_id {
          width: 210px;
        }

        .order_organization {
          width: 140px;
        }

        .order_price {
          width: 70px;
        }

        .order_status {
          width: 70px;
        }

        .order_action {
          width: 110px;
        }

        .pay_now {}
      }

      .order_list_content {
        // height: 800px;
      }

      .order_one {
        font-size: 18px;
        color: #666666;
        font-weight: normal;
        line-height: auto;
        height: 130px;
        border-radius: 10px;

        .order_name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          height: auto;
          text-overflow: ellipsis;
          line-height: 30px;
          //   line-height: 27px;
        }

        .order_price_value {
          color: #ff6619;

          .price_num {
            font-size: 22px;
          }
        }

        .status_active {
          color: #13d6aa;
        }

        .action_btn {
          width: 103px;
          height: 42px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 21px;
          color: #ffffff;
          line-height: 42px;
          text-align: center;
        }

        .cancel_btn {
          background: none;
          color: #13d6aa;
        }
      }

      .active_order_one {
        background: #f8f9fa;
      }
    }

    .pagination_box {}
  }
}
</style>
